import { t } from "@/i18n";

export type Period = 7 | 30 | 90;

const PERIODS: Period[] = [7, 30, 90];

interface PeriodTabsProps {
  value: Period;
  onChange: (period: Period) => void;
}

/** Donem sekmeleri (7/30/90 gun) — gidisat ozeti ve KPI sayfasi ortak kullanir. */
export function PeriodTabs({ value, onChange }: PeriodTabsProps) {
  return (
    <div role="tablist" aria-label={t("ozet.title")} className="inline-flex gap-1 rounded-lg bg-bg p-1">
      {PERIODS.map((period) => {
        const selected = period === value;
        return (
          <button
            key={period}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(period)}
            className={`min-h-[44px] rounded-md px-3 text-sm font-medium transition-colors ${
              selected ? "bg-card text-brand-primary shadow-sm" : "text-muted hover:text-ink"
            }`}
          >
            {t(`ozet.period.${period}`)}
          </button>
        );
      })}
    </div>
  );
}
